/**
 * Aaliyan Gul - cpc-widget-grid.js
 * Metric (m) + Imperial (ft) support with correct qty on submit
 */

(function () {
  'use strict';

  // ── Helpers ────────────────────────────────────────────────
  function roundHalf(n) { return Math.round(n * 2) / 2; }
  function mToFt(m)     { return m / 0.3048; }
  function ftToM(ft)    { return ft * 0.3048; }
  function m2ToFt2(m2)  { return m2 * 10.7639; }

  function selectClosestOption(selectEl, targetVal) {
    var best = selectEl.options[0];
    var bestDelta = Infinity;
    Array.from(selectEl.options).forEach(function (opt) {
      var d = Math.abs(parseFloat(opt.value) - targetVal);
      if (d < bestDelta) { bestDelta = d; best = opt; }
    });
    selectEl.value = best.value;
  }

  // ── Build select options ───────────────────────────────────
  function buildOptions(selectEl, unit) {
    selectEl.innerHTML = '';
    var steps = unit === 'metric' ? 60 : 200; // metric: 1–30.5m | imperial: 0.5–100ft
    for (var i = 1; i <= steps; i++) {
      var val  = unit === 'metric' ? (i * 0.5 + 0.5) : (i * 0.5);
      var opt  = document.createElement('option');
      opt.value       = val.toFixed(1);
      opt.textContent = val.toFixed(1) + (unit === 'metric' ? ' m' : ' ft');
      selectEl.appendChild(opt);
    }
  }

  // ── Calculate qty from widget state (always meters based) ──
  function calcQtyFromWidget(widget, unit) {
    var selLength = widget.querySelector('.cpc-grid-length');
    var selWidth  = widget.querySelector('.cpc-grid-width');
    var rawLen    = parseFloat(selLength && selLength.value) || 1;
    var rawWid    = parseFloat(selWidth  && selWidth.value)  || 1;
    var lenM      = unit === 'imperial' ? ftToM(rawLen) : rawLen;
    var widM      = unit === 'imperial' ? ftToM(rawWid) : rawWid;
    return Math.ceil(lenM * widM * 10);
  }

  // ── Per-widget initialisation ──────────────────────────────
  function initWidget(widget) {
    if (widget._cpcInited) return;
    widget._cpcInited = true;

    var unitPrice   = parseFloat(widget.dataset.unitPrice) || 0;
    var variantId   = widget.dataset.variantId;
    var currentUnit = 'metric';

    var selLength   = widget.querySelector('.cpc-grid-length');
    var selWidth    = widget.querySelector('.cpc-grid-width');
    var priceNum    = widget.querySelector('.cpc-grid-widget__price-num');
    var lengthLabel = widget.querySelector('.cpc-length-label');
    var widthLabel  = widget.querySelector('.cpc-width-label');
    var unitBtns    = widget.querySelectorAll('.cpc-grid-widget__unit-btn');

    // Build initial metric options
    buildOptions(selLength, 'metric');
    buildOptions(selWidth,  'metric');

    function getForm() {
      return document.querySelector(
        'product-form form input[value="' + variantId + '"]'
      )?.closest('form');
    }

    function setHidden(form, name, value) {
      var el = form.querySelector('input[name="' + name + '"]');
      if (!el) {
        el = document.createElement('input');
        el.type = 'hidden'; el.name = name;
        form.appendChild(el);
      }
      el.value = value;
    }

    function forceQty(form) {
      // Always fresh-calculate — never rely on stale _correctQty
      var qty = calcQtyFromWidget(widget, currentUnit);
      form.querySelectorAll('input[name="quantity"]').forEach(function (el) {
        el.value = qty; el.setAttribute('value', qty);
      });
    }

    function update() {
      var rawLen = parseFloat(selLength.value) || 1;
      var rawWid = parseFloat(selWidth.value)  || 1;
      var lenM   = currentUnit === 'imperial' ? ftToM(rawLen) : rawLen;
      var widM   = currentUnit === 'imperial' ? ftToM(rawWid) : rawWid;
      var areaM2 = lenM * widM;
      var qty    = Math.ceil(areaM2 * 10);
      var price  = unitPrice * qty;

      // Store current unit so submit can read it
      widget._currentUnit = currentUnit;
      widget._correctQty  = qty;

      // ── 1. Widget price bar ──
      if (priceNum) priceNum.textContent = price.toFixed(2);

      // ── 2. Card price display ──
      // ── 2. Card price display ──
// ── 2. Card price display ──
var card = widget.closest('.swiper-slide, .card-wrapper, li, .grid__item');
if (card) {
  var fmt = '\u00A3' + price.toFixed(2);

  // Regular price container
  var regularEl = card.querySelector('.price__regular .price-item--regular');
  if (regularEl) regularEl.textContent = fmt;

  // Sale price (last visible)
  var saleEl = card.querySelector('.price-item--sale.price-item--last');
  if (saleEl) saleEl.textContent = fmt;

  // Hide sale div, show regular only — no strikethrough confusion
  var priceRegDiv = card.querySelector('.price__regular');
  var priceSaleDiv = card.querySelector('.price__sale');
  if (priceRegDiv)  priceRegDiv.style.display  = 'block';
  if (priceSaleDiv) priceSaleDiv.style.display = 'none';
}

      var form = getForm();
      if (!form) return;

      // ── 3. Qty input ──
      var qtyInput = form.querySelector('input.quantity__input, input[name="quantity"]');
      if (qtyInput) {
        qtyInput.value = qty;
        qtyInput.setAttribute('value', qty);
        qtyInput.setAttribute('data-length', rawLen);
        qtyInput.setAttribute('data-width',  rawWid);
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        qtyInput.dispatchEvent(new Event('input',  { bubbles: true }));
      }

      // ── 4. Line item properties ──
      var uLabel = currentUnit === 'imperial' ? ' ft' : ' m';
      var aLabel = currentUnit === 'imperial'
        ? m2ToFt2(areaM2).toFixed(2) + ' ft\u00B2 (' + areaM2.toFixed(2) + ' m\u00B2)'
        : areaM2.toFixed(2) + ' m\u00B2';

      setHidden(form, 'properties[Length]',     rawLen.toFixed(2) + uLabel);
      setHidden(form, 'properties[Width]',      rawWid.toFixed(2) + uLabel);
      setHidden(form, 'properties[Total Area]', aLabel);
    }

    // ── Switch unit ───────────────────────────────────────────
    function switchUnit(newUnit) {
      if (newUnit === currentUnit) return;

      // Save current values in meters before rebuilding options
      var rawLen = parseFloat(selLength.value) || 1;
      var rawWid = parseFloat(selWidth.value)  || 1;
      var lenM   = currentUnit === 'imperial' ? ftToM(rawLen) : rawLen;
      var widM   = currentUnit === 'imperial' ? ftToM(rawWid) : rawWid;

      currentUnit = newUnit;

      // Toggle active button
      unitBtns.forEach(function (b) {
        b.classList.toggle('active', b.dataset.unit === newUnit);
      });

      // Update labels
      var ul = newUnit === 'imperial' ? 'ft' : 'm';
      if (lengthLabel) lengthLabel.textContent = 'Length (' + ul + ')';
      if (widthLabel)  widthLabel.textContent  = 'Width ('  + ul + ')';

      // Rebuild options
      buildOptions(selLength, newUnit);
      buildOptions(selWidth,  newUnit);

      // Restore closest equivalent value in new unit
      var targetLen = newUnit === 'imperial' ? roundHalf(mToFt(lenM)) : roundHalf(lenM);
      var targetWid = newUnit === 'imperial' ? roundHalf(mToFt(widM)) : roundHalf(widM);
      selectClosestOption(selLength, targetLen);
      selectClosestOption(selWidth,  targetWid);

      update();
    }

    // ── Unit toggle buttons ───────────────────────────────────
    unitBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        switchUnit(this.dataset.unit);
      });
    });

    selLength.addEventListener('change', update);
    selWidth.addEventListener('change',  update);

    // ── Submit capture — fires BEFORE Shopify/Extendons ───────
    function bindSubmitBtn(form) {
      var btn = form.querySelector('button[type="submit"], button[name="add"]');
      if (btn && !btn._cpcClickBound) {
        btn._cpcClickBound = true;
        btn.addEventListener('click', function () { forceQty(form); }, true);
      }
    }

    // ── Submit bubbling — fires AFTER Extendons ───────────────
    function bindFormSubmit(form) {
      if (form._cpcSubmitBound) return;
      form._cpcSubmitBound = true;
      form.addEventListener('submit', function () { forceQty(form); }, false);
    }

    var form = getForm();
    if (form) {
      bindSubmitBtn(form);
      bindFormSubmit(form);
    }

    // ── Pond Calculator Bridge ────────────────────────────────
    // rawLengthM / rawWidthM always METERS from pond-calculator
    widget._syncFromCalc = function (rawLengthM, rawWidthM, unit) {
      if (unit && unit !== currentUnit) switchUnit(unit);

      if (currentUnit === 'imperial') {
        selectClosestOption(selLength, roundHalf(mToFt(rawLengthM)));
        selectClosestOption(selWidth,  roundHalf(mToFt(rawWidthM)));
      } else {
        selectClosestOption(selLength, roundHalf(rawLengthM));
        selectClosestOption(selWidth,  roundHalf(rawWidthM));
      }
      update();
    };

    update();
  }

  // ── Boot ──────────────────────────────────────────────────
  function initAll() {
    document.querySelectorAll('.cpc-grid-widget').forEach(initWidget);
  }

  // ── MutationObserver: Swiper lazy slides ──────────────────
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        var widgets = node.matches && node.matches('.cpc-grid-widget')
          ? [node]
          : Array.from(node.querySelectorAll ? node.querySelectorAll('.cpc-grid-widget') : []);
        widgets.forEach(initWidget);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  // ── Pond Calculator Event Bridge ──────────────────────────
  document.addEventListener('pondCalcUpdated', function (e) {
    var rawL = e.detail.rawLengthM;
    var rawW = e.detail.rawWidthM;
    var unit = e.detail.unit || null;
    document.querySelectorAll('.cpc-grid-widget').forEach(function (w) {
      if (w._syncFromCalc) w._syncFromCalc(rawL, rawW, unit);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

})();
function setActive(clickedButton) {
    document.querySelectorAll('.unit-toggle__button').forEach(b => b.classList.remove('unit-toggle__button--active'));
    clickedButton.classList.add('unit-toggle__button--active');
    currentUnit = clickedButton.dataset.unit;

    // ── NEW: sync card widgets unit toggle ──
    document.dispatchEvent(new CustomEvent('pondCalcUnitChanged', {
        detail: { unit: currentUnit }
    }));
}
// ── Unit-only sync from pond-calculator toggle ────────────
document.addEventListener('pondCalcUnitChanged', function (e) {
    var unit = e.detail.unit;
    document.querySelectorAll('.cpc-grid-widget').forEach(function (w) {
        if (w._syncFromCalc) {
            // Get current meter values from widget selects
            var selLen = w.querySelector('.cpc-grid-length');
            var selWid = w.querySelector('.cpc-grid-width');
            var curUnit = w._currentUnit || 'metric';
            var rawLen = parseFloat(selLen && selLen.value) || 1;
            var rawWid = parseFloat(selWid && selWid.value) || 1;
            // Convert current selection to meters
            var lenM = curUnit === 'imperial' ? rawLen * 0.3048 : rawLen;
            var widM = curUnit === 'imperial' ? rawWid * 0.3048 : rawWid;
            // Sync with new unit
            w._syncFromCalc(lenM, widM, unit);
        }
    });
});